<ion-item-group>
    <ind-section-header *ngIf="pendingSyncConsents.length > 0" [viewData]='contactConsentPendingHeader'></ind-section-header>
    <!-- <ion-list *ngIf="pendingSyncConsents.length > 0 && uiService.isConsentFromToolDrawer">
      <omni-accordion [viewData]="consent" *ngFor="let consent of pendingSyncConsentsModel; trackBy: trackById"></omni-accordion>
    </ion-list> -->
    <!-- OLD IMPLEMENTATION - Commented out for rollback -->
    <!-- <ion-list class="consent-sub-header">
      <ion-item-group *ngFor="let consent of pendingSyncConsentsGrid; trackBy: trackById" class="consent-grid">
        <ion-item lines="none" class="remove_inner_bottom ion-no-padding" (click)="handlePendingSyncConsentExpandClick(consent.id, $event, 'mainLabel')">
          <ion-icon slot="start" name="indegene-consent-main" class="consent-icon"> </ion-icon>
          <ion-label class="consent-name"> {{consent.consentTermName}} </ion-label>
          <ion-buttons slot="end" *ngIf="isOptOutEnabled"
            (click)="optOutFromConsent($event, consent)" class="section-header-button-text"
            [disabled]="true">
            <div> {{ 'OPT_OUT' | translate }} </div>
          </ion-buttons>
        </ion-item>
        <ion-item lines="none" class="remove_inner_bottom ion-no-padding" (click)="handlePendingSyncConsentExpandClick(consent.id, $event, 'mainLabel')">
          <ion-grid>
            <ion-row *ngFor="let childItem of consent.childItems; trackBy: trackById">
              <ion-col size="4" *ngFor="let item of childItem; trackBy: trackById" >
                <div class="display-grid" *ngIf="!item.isMultipleValue">
                  <ion-text class="child-item-label">{{ item.label }}</ion-text>
                  <ion-label class="child-item-text">{{ item.value }}</ion-label>
                </div>
                <div *ngIf="item.isMultipleValue" class="second-level-div">
                  <ion-row>
                    <ion-col size="8" size-xs="7">
                      <div class="display-grid">
                        <ion-text class="child-item-label">{{ item.label }}</ion-text>
                        <ion-label class="child-item-text">{{ item.value }}</ion-label>
                      </div>
                    </ion-col>
                    <ion-col size="4" size-xs="5">
                      <div class="display-grid">
                        <ion-text class="child-item-label drop-down-label">{{ item.label }}</ion-text>
                        <ion-buttons (click)="expandItemValues(item, $event)">
                          <ion-label class="child-item-text drop-down-text">{{ item.dropDownText }}</ion-label>
                          <ion-icon class="arrow-icon" name='chevron-down-outline' slot="start"></ion-icon>
                        </ion-buttons>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
      </ion-item-group>
    </ion-list> -->

    <!-- NEW IMPLEMENTATION - Single aggregated record for pending consents -->
    <ion-list class="consent-sub-header" *ngIf="pendingSyncConsents.length > 0">
      <ion-item-group *ngFor="let consent of newPendingSyncConsentsGrid; trackBy: trackById" class="consent-grid" data-testid="consent-pending-row">
        <ion-item data-testid="consent-pending-row-header" lines="none" class="remove_inner_bottom ion-no-padding" (click)="handleNewConsentExpandClick(pendingSyncConsents, true, $event)">
          <ion-icon slot="start" name="indegene-consent-main" class="consent-icon"> </ion-icon>
          <ion-label class="consent-name"> {{consent.consentTermName}} </ion-label>
        </ion-item>
        <ion-item data-testid="consent-pending-row-details" lines="none" class="remove_inner_bottom ion-no-padding" (click)="handleNewConsentExpandClick(pendingSyncConsents, true, $event)">
          <ion-grid>
            <ion-row *ngFor="let childItem of consent.childItems; trackBy: trackById">
              <ion-col size="4" *ngFor="let item of childItem; trackBy: trackById">
                <div class="display-grid" *ngIf="!item.isMultipleValue">
                  <ion-text class="child-item-label">{{ item.label }}</ion-text>
                  <ion-label class="child-item-text">{{ item.value }}</ion-label>
                </div>
                <div *ngIf="item.isMultipleValue" class="second-level-div">
                  <ion-row>
                    <ion-col size="8" size-xs="7">
                      <div class="display-grid">
                        <ion-text class="child-item-label">{{ item.label }}</ion-text>
                        <ion-label class="child-item-text">{{ item.value }}</ion-label>
                      </div>
                    </ion-col>
                    <ion-col size="4" size-xs="5">
                      <div class="display-grid">
                        <ion-text class="child-item-label drop-down-label">{{ item.label }}</ion-text>
                        <ion-buttons (click)="expandItemValues(item, $event)">
                          <ion-label class="child-item-text drop-down-text">{{ item.dropDownText }}</ion-label>
                          <ion-icon class="arrow-icon" name='chevron-down-outline' slot="start"></ion-icon>
                        </ion-buttons>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
      </ion-item-group>
    </ion-list>

    <!-- Active Consents - All list -->
    <div>
      <ind-section-header *ngIf="!isOptOutFiltered" [viewData]='contactConsentActiveHeader' (onFilterClick)="openActiveConsentsFilter($event)" (onControlClick)="onSectionHeaderControlClick($event)"></ind-section-header>
      <div *ngIf="activeConsents.length == 0 && pendingSyncConsents.length == 0 && !isFilterApplied" class="all-consents no-data-message">{{ 'CONTACT_NO_CONSENTS' | translate}}</div>
      <!-- <ion-list>
          <omni-accordion [viewData]="consent" *ngFor="let consent of activeConsentsModel; trackBy: trackById"></omni-accordion>
      </ion-list> -->
      <!-- OLD IMPLEMENTATION - Commented out for rollback -->
      <!-- <ion-list class="consent-sub-header">
        <ion-item-group *ngFor="let consent of activeConsentsGrid; trackBy: trackById" class="consent-grid">
          <ion-item lines="none" class="remove_inner_bottom ion-no-padding" (click)="handleActiveConsentExpandClick(consent.id, $event, 'mainLabel')">
            <ion-icon slot="start" name="indegene-consent-main" class="consent-icon"> </ion-icon>
            <ion-label class="consent-name"> {{consent.consentTermName}} </ion-label>
            <ion-buttons slot="end" *ngIf="isOptOutEnabled"
              (click)="optOutFromConsent($event, consent)" class="section-header-button-text-card"
              [disabled]="consent.isOptOutDisabled">
              <div> {{ 'OPT_OUT' | translate }} </div>
            </ion-buttons>
            <ion-icon *ngIf="!readOnly" slot="end" src="assets/imgs/ellipsis.svg" class="consent-more-option-icon" (click)="openMoreOptions(consent.id, $event, 'mainLabel')"> </ion-icon>
          </ion-item>
          <ion-item lines="none" class="remove_inner_bottom ion-no-padding" (click)="handleActiveConsentExpandClick(consent.id, $event, 'mainLabel')">
            <ion-grid>
              <ion-row *ngFor="let childItem of consent.childItems; trackBy: trackById">
                <ion-col size="4" *ngFor="let item of childItem; trackBy: trackById">
                  <div class="display-grid" *ngIf="!item.isMultipleValue">
                    <ion-text class="child-item-label">{{ item.label }}</ion-text>
                    <ion-label class="child-item-text">{{ item.value }}</ion-label>
                  </div>
                  <div *ngIf="item.isMultipleValue" class="second-level-div">
                    <ion-row>
                      <ion-col size="8" size-xs="7">
                        <div class="display-grid">
                          <ion-text class="child-item-label">{{ item.label }}</ion-text>
                          <ion-label class="child-item-text">{{ item.value }}</ion-label>
                        </div>
                      </ion-col>
                      <ion-col size="4" size-xs="5">
                        <div class="display-grid">
                          <ion-text class="child-item-label drop-down-label">{{ item.label }}</ion-text>
                          <ion-buttons (click)="expandItemValues(item, $event)">
                            <ion-label class="child-item-text drop-down-text">{{ item.dropDownText }}</ion-label>
                            <ion-icon class="arrow-icon" name='chevron-down-outline' slot="start"></ion-icon>
                          </ion-buttons>
                        </div>
                      </ion-col>
                    </ion-row>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>
        </ion-item-group>
      </ion-list> -->
      
      <!--New implementation for filtered active consents-->
      <ind-section-header *ngIf="isOptOutFiltered" [viewData]='filteredConsentActiveHeader' (onFilterClick)="openActiveConsentsFilter($event)" (onControlClick)="onSectionHeaderControlClick($event)"></ind-section-header>
      <ion-item-group *ngIf="isOptOutFiltered" class="selected-filter">
        <ion-item lines="none" class="remove_inner_bottom ion-no-padding filter-header">
          <ion-grid>
            <ion-row>
              <ion-col size="auto" class="filter-item" *ngFor="let filter of selectedFilters; trackBy: trackById">
                <div class="display-grid">
                  <ion-text class="child-item-label">{{ filter.label }}</ion-text>
                  <ion-label class="child-item-text">{{ filter.value }}</ion-label>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
          <ion-buttons slot="end" data-testid="consent-filtered-opt-out-from-all" (click)="optOutFromAllConsent($event)" class="section-header-button-text" [class.button-disabled]="!hasFilteredConsentActivity">
            <div> {{ 'OPT_OUT_FROM_ALL' | translate }} </div>
          </ion-buttons>
        </ion-item>
      </ion-item-group>

      <!-- NEW IMPLEMENTATION - Single aggregated record for active consents -->
      <ion-list class="consent-sub-header" *ngIf="activeConsents.length > 0">
        <ion-item-group *ngFor="let consent of newActiveConsentsGrid; trackBy: trackById" class="consent-grid" data-testid="consent-active-row">
          <ion-item data-testid="consent-active-row-header" lines="none" class="remove_inner_bottom ion-no-padding" (click)="handleNewConsentExpandClick(activeConsents, false, $event)">
            <ion-icon slot="start" name="indegene-consent-main" class="consent-icon"> </ion-icon>
            <ion-label class="consent-name"> {{consent.consentTermName}} </ion-label>
            <ion-icon *ngIf="!readOnly" slot="end" src="assets/imgs/ellipsis.svg" class="consent-more-option-icon" data-testid="consent-active-row-more-options" (click)="openMoreOptions(consent.id, $event, 'mainLabel')"> </ion-icon>
          </ion-item>
          <ion-item data-testid="consent-active-row-details" lines="none" class="remove_inner_bottom ion-no-padding" (click)="handleNewConsentExpandClick(activeConsents, false, $event)">
            <ion-grid>
              <ion-row *ngFor="let childItem of consent.childItems; trackBy: trackById">
                <ion-col size="4" *ngFor="let item of childItem; trackBy: trackById">
                  <div class="display-grid" *ngIf="!item.isMultipleValue">
                    <ion-text class="child-item-label">{{ item.label }}</ion-text>
                    <ion-label class="child-item-text">{{ item.value }}</ion-label>
                  </div>
                  <div *ngIf="item.isMultipleValue" class="second-level-div">
                    <ion-row>
                      <ion-col size="8" size-xs="7">
                        <div class="display-grid">
                          <ion-text class="child-item-label">{{ item.label }}</ion-text>
                          <ion-label class="child-item-text">{{ item.value }}</ion-label>
                        </div>
                      </ion-col>
                      <ion-col size="4" size-xs="5">
                        <div class="display-grid">
                          <ion-text class="child-item-label drop-down-label">{{ item.label }}</ion-text>
                          <ion-buttons (click)="expandItemValues(item, $event)">
                            <ion-label class="child-item-text drop-down-text">{{ item.dropDownText }}</ion-label>
                            <ion-icon class="arrow-icon" name='chevron-down-outline' slot="start"></ion-icon>
                          </ion-buttons>
                        </div>
                      </ion-col>
                    </ion-row>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>
        </ion-item-group>
      </ion-list>
    </div>

    <!--Old implementation for filtered active consents-->
    <!-- Active Consents - Filtered list For Opt Out -->
    <!-- <div *ngIf="isOptOutFiltered">
      <ind-section-header *ngIf="isOptOutFiltered" [viewData]='filteredConsentActiveHeader' (onFilterClick)="openActiveConsentsFilter($event)" (onControlClick)="onSectionHeaderControlClick($event)"></ind-section-header>
      <ion-item-group *ngIf="isOptOutFiltered" class="selected-filter">
        <ion-item lines="none" class="remove_inner_bottom ion-no-padding filter-header">
          <ion-grid>
            <ion-row>
              <ion-col size="auto" class="filter-item" *ngFor="let filter of selectedFilters; trackBy: trackById">
                <div class="display-grid">
                  <ion-text class="child-item-label">{{ filter.label }}</ion-text>
                  <ion-label class="child-item-text">{{ filter.value }}</ion-label>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
          <ion-buttons slot="end" (click)="optOutFromAllConsent($event)" class="section-header-button-text" [disabled]="filteredActiveConsentsGrid.length == 0">
            <div> {{ 'OPT_OUT_FROM_ALL' | translate }} </div>
          </ion-buttons>
        </ion-item>
      </ion-item-group> -->

      <!-- Filtered section still uses old grid for opt-out functionality -->
      <!-- <ion-list class="consent-sub-header">
        <ion-item-group *ngFor="let consent of filteredActiveConsentsGrid; trackBy: trackById" class="consent-grid">
          <ion-item lines="none" class="remove_inner_bottom ion-no-padding" (click)="openNewConsentsDetailScreen(activeConsents, false)">
            <ion-icon slot="start" name="indegene-consent-main" class="consent-icon"> </ion-icon>
            <ion-label class="consent-name"> {{consent.consentTermName}} </ion-label>
            <ion-buttons slot="end"
              (click)="optOutFromConsent($event, consent)" class="section-header-button-text-card"
              [disabled]="consent.isOptOutDisabled">
              <div> {{ 'OPT_OUT' | translate }} </div>
            </ion-buttons>
          </ion-item>
          <ion-item lines="none" class="remove_inner_bottom ion-no-padding" (click)="openNewConsentsDetailScreen(activeConsents, false)">
            <ion-grid>
              <ion-row *ngFor="let childItem of consent.childItems; trackBy: trackById">
                <ion-col size="4" *ngFor="let item of childItem; trackBy: trackById">
                  <div class="display-grid" *ngIf="!item.isMultipleValue">
                    <ion-text class="child-item-label">{{ item.label }}</ion-text>
                    <ion-label class="child-item-text">{{ item.value }}</ion-label>
                  </div>
                  <div class="display-grid" *ngIf="item.isMultipleValue">
                    <ion-row>
                      <ion-col size="8">
                        <div class="display-grid">
                          <ion-text class="child-item-label">{{ item.label }}</ion-text>
                          <ion-label class="child-item-text">{{ item.value }}</ion-label>
                        </div>
                      </ion-col>
                      <ion-col size="4">
                        <div class="display-grid">
                          <ion-text class="child-item-label drop-down-label">{{ item.label }}</ion-text>
                          <ion-buttons (click)="expandItemValues(item, $event)">
                            <ion-label class="child-item-text drop-down-text">{{ item.dropDownText }}</ion-label>
                            <ion-icon class="arrow-icon" name='chevron-down-outline' slot="start"></ion-icon>
                          </ion-buttons>
                        </div>
                      </ion-col>
                    </ion-row>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>
        </ion-item-group>
      </ion-list>
    </div> -->
</ion-item-group>
